import React from 'react';
import { colorBrandYamahaRed } from '@yme/tokens/colors';
import { RegularLabelLevel1 } from '@yme/tokens/typography';
import { EMAIL_PREFIX, SUPPORT_EMAIL } from '../CycleSchemeOption';
export const TransformedTextToReactNode = ({ text }) => {
    const regex = /\{email}/;
    const match = text.match(regex);
    if (!match)
        return React.createElement("span", null, text);
    const email = SUPPORT_EMAIL;
    const emailPrefix = EMAIL_PREFIX;
    const startIndex = match.index ?? 0;
    const endIndex = startIndex + match[0].length;
    const before = text.substring(0, startIndex);
    const after = text.substring(endIndex);
    return (React.createElement("span", null,
        before,
        React.createElement(RegularLabelLevel1, { as: "a", color: colorBrandYamahaRed, href: `${emailPrefix}${email}` }, email),
        after));
};
